import { z } from 'zod';
// Shared schema for the three picklist tables (list_basins, list_regions,
// list_segments). All three share identical column shape — one schema
// serves all three with no discriminator.
//
// DB columns mirrored from public.list_basins / list_regions / list_segments:
//   display_value text NOT NULL
//   storage_value text NOT NULL
//   sequence      int  NOT NULL  (no DB default)
//   is_active     bool NOT NULL  DEFAULT true
//   is_default    bool NULLABLE  DEFAULT false
// (id, company_id, created/modified/created_by/updated_by are all
//  populated server-side and excluded from the create surface.)
//
// `.passthrough()` lets future DB columns flow through to the DB
// instead of being silently stripped at the Zod boundary (cf. the
// settings 500 + audit-mirrored class of bug). No length caps —
// columns are `text` and the JWT-side route has accepted unlimited
// length since Phase 1; the new external surface matches.
export const picklistCreateSchema = z
    .object({
    display_value: z.string().min(1),
    storage_value: z.string().min(1),
    sequence: z.number(),
    is_active: z.boolean().optional(),
    is_default: z.boolean().nullable().optional(),
})
    .passthrough();
export const picklistUpdateSchema = picklistCreateSchema.partial();
//# sourceMappingURL=picklistSchema.js.map